// Mirrors memrise.user_stats.entities.RANKS (webapp/memrise/user_stats/entities.py).
// Order matters: index + 1 is the rank_index used to build icon URLs
// (static/img/icons/ranks/<rank_index>_outline.svg).
module.exports = [
  { id: "membryo", points: 0 },
  { id: "member", points: 500 },
  { id: "memdicant", points: 1000 },
  { id: "memorandom", points: 2000 },
  { id: "memtor", points: 4000 },
  { id: "mempee", points: 8000 },
  { id: "memcache", points: 16000 },
  { id: "memgineer", points: 32000 },
  { id: "memonimee", points: 64000 },
  { id: "memblem", points: 128000 },
  { id: "memmoth", points: 320000 },
  { id: "memocrat", points: 800000 },
  { id: "membrain", points: 2000000 },
  { id: "memonist", points: 5000000 },
  { id: "membassador", points: 12500000 },
  { id: "meminence", points: 31250000 },
  { id: "memperor", points: 78125000 },
  { id: "overlord", points: 100000000 },
];
